import { InputText } from "primereact/inputtext";

const AIEduInputText = (props) => {
    const { title, titleStyle, suffix } = props;

    return (
        <div>
            <span
                className="mt-3"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                }}
            >
                <label htmlFor={title} className={titleStyle}>
                    {title} {suffix}
                </label>
                <InputText {...props} />
            </span>
        </div>
    );
};

export default AIEduInputText;
